import { render, staticRenderFns } from "./refundReason.vue?vue&type=template&id=0f45a964&scoped=true"
import script from "./refundReason.vue?vue&type=script&lang=js"
export * from "./refundReason.vue?vue&type=script&lang=js"
import style0 from "./refundReason.vue?vue&type=style&index=0&id=0f45a964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45a964",
  null
  
)

export default component.exports